import { supabase } from '../client';

export interface EmailTemplate {
  id: string;
  org_id: string;
  key: string;
  name: string;
  subject: string;
  body_html: string;
  variables: string[];
  is_system: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export type EmailTemplateUpsert = Pick<
  EmailTemplate,
  'key' | 'name' | 'subject' | 'body_html' | 'variables'
>;

export const emailTemplateService = {
  async list(orgId: string): Promise<EmailTemplate[]> {
    const { data, error } = await supabase
      .from('ggj_b2b_email_templates')
      .select('*')
      .eq('org_id', orgId)
      .order('name');
    if (error) throw error;
    return (data ?? []) as EmailTemplate[];
  },

  async getByKey(orgId: string, key: string): Promise<EmailTemplate | null> {
    const { data, error } = await supabase
      .from('ggj_b2b_email_templates')
      .select('*')
      .eq('org_id', orgId)
      .eq('key', key)
      .maybeSingle();
    if (error) throw error;
    return (data ?? null) as EmailTemplate | null;
  },

  async upsert(orgId: string, userId: string, payload: EmailTemplateUpsert): Promise<EmailTemplate> {
    const { data, error } = await supabase
      .from('ggj_b2b_email_templates')
      .upsert(
        { org_id: orgId, created_by: userId, ...payload },
        { onConflict: 'org_id,key' }
      )
      .select()
      .single();
    if (error) throw error;
    return data as EmailTemplate;
  },

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('ggj_b2b_email_templates')
      .delete()
      .eq('id', id);
    if (error) throw error;
  },
};
